import type { ReactNode, ComponentType } from "react";
import { Icon } from "../Icons/Icon";
import { headingFontStyle } from "../Theme/headingFontStyle";

interface EmptyStateProps {
  icon?: ComponentType<{ className?: string }> | undefined;
  title: string;
  description?: string | undefined;
  action?: ReactNode | undefined;
}

export function EmptyState({
  icon: IconProp,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center py-8 text-center">
      {IconProp && (
        <div className="mb-3">
          <Icon icon={IconProp} size="xl" color="text-content-faint" />
        </div>
      )}
      <div
        className="mb-1 text-sm font-bold text-content"
        style={headingFontStyle()}
      >
        {title}
      </div>
      {description && (
        <div className="mb-4 text-xs text-content-secondary">{description}</div>
      )}
      {action}
    </div>
  );
}
